import MonitorHeartRounded from '@mui/icons-material/MonitorHeartRounded';
import type { ModuleDefinition } from '../types';

export const healthModule: ModuleDefinition = {
  key: 'health',
  label: 'Saúde',
  description: 'Peso, medidas e pressão arterial.',
  icon: MonitorHeartRounded,
  nav: [
    {
      to: '/saude',
      label: 'Saúde',
      icon: MonitorHeartRounded,
      rule: { module: 'health', anyPermission: ['health.self', 'health.clients.read'] },
    },
  ],
  routes: [
    {
      path: '/saude',
      lazy: async () => ({ Component: (await import('./pages/HealthPage')).HealthPage }),
    },
  ],
};
